import App from "./Main.svelte";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
const app = new App({
    target: document.body,
});
export default app;
